import { z, ZodType } from 'zod';
import { Bet, betSchema } from './bet';

export type BetHistory = {
	count: number;
	rows: Bet[];
};

export const betHistorySchema: ZodType<BetHistory> = z.object({
	count: z.number(),
	rows: betSchema.array(),
});
